import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import AuditModal from '../ConfigAudits/AuditModal';

export default function RecordsActionMenu({ row, formato, format_category, estados, domain, configuration_format, onSendEmails, onViewConfirmations, onRefresh, custom_view_id }) {
  const [open, setOpen] = useState(false);
  const [showAudit, setShowAudit] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const dropdownRef = useRef(null);

  const updatePosition = useCallback(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setPos({ top: rect.bottom + 4, left: rect.left });
  }, []);

  const handleToggle = () => {
    if (!open) updatePosition();
    setOpen(!open);
  };

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropdownRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    const handleScroll = () => setOpen(false);
    document.addEventListener('mousedown', handleClickOutside);
    document.querySelector('.cm-dt-scroll')?.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.querySelector('.cm-dt-scroll')?.removeEventListener('scroll', handleScroll);
    };
  }, [open]);

  const fcToken = format_category.token;
  const cvParams = custom_view_id && parseInt(custom_view_id) > 0 ? `?type=own&custom_view_id=${custom_view_id}` : '';
  const gestionUrl = `/formatos/format_categories/${fcToken}/formats/${formato.token}/gestion/${row.token}${cvParams}`;
  const editUrl = `/formatos/format_categories/${fcToken}/formats/${formato.token}/surveys/${row.token}${cvParams}`;

  const handleDelete = async () => {
    if (!confirm('¿Eliminar este registro?')) return;
    const token = document.querySelector("[name='csrf-token']")?.content;
    try {
      await fetch(`/formatos/delete_surveys/${row.id}`, {
        method: 'DELETE',
        headers: { 'X-CSRF-Token': token, 'Content-Type': 'application/json' }
      });
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error(err);
    }
  };

  const showSendEmails = configuration_format &&
    (configuration_format.send_notification_list || configuration_format.send_email_to_extern_list);

  const showViewConfirmations = configuration_format &&
    (configuration_format.send_email_to_extern || configuration_format.send_email_to_extern_list);

  const dropdown = open ? ReactDOM.createPortal(
    <div
      ref={dropdownRef}
      className="cm-action-menu__dropdown"
      style={{ position: 'fixed', top: pos.top, left: pos.left }}
    >
      <a href={gestionUrl} className="cm-action-menu__item">
        <i className="fas fa-eye" /> Gestionar
      </a>
      {estados.edit && (
        <a href={editUrl} className="cm-action-menu__item">
          <i className="fas fa-edit" /> Editar
        </a>
      )}
      {showSendEmails && (
        <button
          className="cm-action-menu__item"
          onClick={() => { onSendEmails(row.id); setOpen(false); }}
        >
          <i className="fas fa-envelope" /> Ejecutar Correos
        </button>
      )}
      {showViewConfirmations && (
        <button
          className="cm-action-menu__item"
          onClick={() => { onViewConfirmations(row.id); setOpen(false); }}
        >
          <i className="fas fa-envelope-open-text" /> Ver Confirmaciones
        </button>
      )}
      {estados.auditHistory && (
        <button
          className="cm-action-menu__item"
          onClick={() => { setShowAudit(true); setOpen(false); }}
        >
          <i className="fas fa-history" /> Ver historial de cambios
        </button>
      )}
      {estados.delete && (
        <button className="cm-action-menu__item cm-action-menu__item--danger" onClick={handleDelete}>
          <i className="fas fa-trash" /> Eliminar
        </button>
      )}
    </div>,
    document.body
  ) : null;

  return (
    <div className="cm-action-menu">
      <button ref={triggerRef} className="cm-action-menu__trigger" onClick={handleToggle}>
        <i className="fas fa-ellipsis-v" />
      </button>
      {dropdown}
      {showAudit && (
        <AuditModal
          mode="record"
          targetId={row.id}
          title={row.code_format || `#${row.survey_count || row.id}`}
          subtitle="Ediciones registradas de este registro."
          toggle={() => setShowAudit(false)}
          showTrashLink={!!estados.auditTrash}
        />
      )}
    </div>
  );
}
